<section class="w-100 d-flex justify-content-center pb-5 pt-1">
  <div class="w-80 d-flex flex-column gap-4 py-5">
    <h2 class="text-center h2-text fw-semibold fs-3-text m-0 mb-3">
      Perval.fr, le site incontournable pour réaliser vos estimations
      immobilières
    </h2>

    <div class="row g-5">
      <div
        class="col-12 col-lg-6 d-flex align-items-center justify-content-center position-relative"
      >
        <div class="image-wrapper position-relative">
          <video
            *ngIf="!showFallbackImage"
            #toolsVideo
            class="tools-video w-100 rounded-top-end-50 rounded-bottom-start-50"
            [class.video-hidden]="!isVideoReady"
            autoplay
            loop
            playsinline
            preload="auto"
            controls
            muted
            (click)="switchSound()"
            (canplay)="onVideoReady()"
            (error)="onVideoError()"
          >
            <source
              src="assets/videos/tools_section_video.webm"
              type="video/webm"
            />
          </video>

          <ng-container *ngIf="!isVideoReady">
            <img
              class="w-100 rounded-top-end-50 rounded-bottom-start-50"
              src="assets/images/tools_section_picture.webp"
              alt="tools section"
            />
            <div
              class="image-overlay rounded-top-end-50 rounded-bottom-start-50 position-absolute"
            ></div>

            <img
              class="va-colored-logo position-absolute top-50 start-50 translate-middle"
              src="assets/perval-icons/va_colored.svg"
              alt="va logo"
            />
          </ng-container>
        </div>
      </div>

      <div
        class="col-12 col-lg-6 d-flex flex-column align-items-start justify-content-center"
      >
        <div
          class="d-flex flex-column align-items-center align-items-lg-start justify-content-center gap-2"
        >
          <div class="d-flex gap-2 align-items-center justify-content-center">
            <img
              class="a"
              src="assets/perval-icons/small_va.svg"
              alt="VA logo"
            />
            <p class="fs-5 m-0 fw-bold">Outil d'évaluation</p>
          </div>
          <ul>
            <li>
              <p class="fs-5-personnalize mb-2">
                Obtenez rapidement une fourchette de prix à partir des
                comparables sélectionnés, suite à l'achat d'une liste, en
                demandant à " Évaluer le bien " ou
              </p>
            </li>
            <li>
              <p class="fs-5-personnalize m-0">
                Obtenez une fourchette de prix directement en saisissant
                l'adresse et les surfaces du bien, grâce à la fonction
                Évaluation automatique
              </p>
            </li>
          </ul>
        </div>

        <hr class="hr" />

        <div
          class="d-flex flex-column align-items-center align-items-lg-start justify-content-center gap-2"
        >
          <div class="d-flex align-items-center justify-content-center gap-2">
            <img
              class="a"
              src="assets/perval-icons/small_va.svg"
              alt="VA logo"
            />
            <p class="fs-5 fw-bold m-0">Rapport d'avis de valeur</p>
          </div>
          <ul>
            <li>
              <p class="fs-5-personnalize mb-2 align-self-start">
                Le rapport d'avis de valeur Perval est édité au format word,
                entièrement modulable
              </p>
            </li>
            <li>
              <p class="fs-5-personnalize m-0">
                Vous retrouvez vos références et votre estimation directement
                dans le rapport avec les tendances de marché (indice Insee et
                données cadastrales)
              </p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>
